var _defs, _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1558 1210",
    width: 1558,
    height: 1210,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "006-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 695.4,
    y1: 888.1,
    x2: 482.2,
    y2: 937.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#60b0e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#916eb0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x1: 675.6,
    y1: 921.6,
    x2: 790.9,
    y2: 621.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#60b0e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#916eb0"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { fill: #f9f9f9 } \r\n\t\t.s1 { fill: #f0f0f0 } \r\n\t\t.s2 { fill: #c2c2fa } \r\n\t\t.s3 { fill: #442f86 } \r\n\t\t.s4 { fill: url(#g1) } \r\n\t\t.s5 { fill: #9186dd } \r\n\t\t.s6 { fill: #bbd1f5 } \r\n\t\t.s7 { fill: url(#g2) } \r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1515.8 721.8c-26-72.3-66.8-94.3-105.6-140.6-47.5-56.7-79.4-97.8-67.1-170.7 20.1-119 28.7-415.8-286.4-377-132.3 16.3-207.2 104.8-255.8 182-160.2 254.4-202.5 31-535.1 201.4-187.3 96-243.2 234-235.6 410.5 9.4 215.7 187.2 358.5 396.9 358.7 197.6 0.2 253.7-108.4 510.5-119.2 122.2-11.9 248.8 9.5 366-27 61.9-19.2 118.8-54.5 163.6-101.5 56-58.6 75.9-140.3 48.6-216.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m631.9 562.9h-10.9c-7.5 0-13.5 6.1-13.5 13.5v21.9c0 7.5-6.1 13.5-13.5 13.5h-66.3c-7.5 0-13.5-6-13.5-13.5v-21.9c0-7.4-6.1-13.5-13.5-13.5h-120.9c-7.5 0-13.5-6-13.5-13.5v-43.4c0-2.7 0.8-5.4 2.4-7.7l114.6-165.9c2.5-3.7 6.6-5.8 11.1-5.8h66.3c10.8 0 17.2 12 11.2 20.9l-79.6 119.8c-6 9 0.4 21 11.2 21 7.5 0 13.5-6 13.5-13.5v-16.6c0-7.4 6.1-13.5 13.5-13.5h63.5c7.4 0 13.5 6.1 13.5 13.5v16.6c0 7.5 6 13.5 13.5 13.5h10.9c7.4 0 13.5 6.1 13.5 13.5v47.6c0 7.5-6.1 13.5-13.5 13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m721 600.6q-29.2-17.7-45.7-51.3-16.5-33.7-16.5-80.1 0-46.5 16.5-80.1 16.5-33.6 45.7-51.3 29.1-17.8 67-17.8 37.9 0 67 17.8 29.2 17.7 45.7 51.3 16.5 33.6 16.5 80.1 0 46.4-16.5 80.1-16.5 33.6-45.7 51.3-29.1 17.7-67 17.7-37.9 0-67-17.7zm99.6-131.4q0-72.1-32.6-72.1-32.6 0-32.6 72.1 0 72.1 32.6 72.1 32.6 0 32.6-72.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1204 562.9h-10.9c-7.4 0-13.5 6.1-13.5 13.5v21.9c0 7.5-6 13.5-13.5 13.5h-66.3c-7.5 0-13.5-6-13.5-13.5v-21.9c0-7.4-6.1-13.5-13.5-13.5h-120.9c-7.5 0-13.5-6-13.5-13.5v-43.4c0-2.7 0.8-5.4 2.4-7.7l114.6-165.9c2.5-3.7 6.6-5.8 11.1-5.8h66.3c10.8 0 17.2 12 11.3 20.9l-79.7 119.8c-6 9 0.5 21 11.2 21 7.5 0 13.5-6 13.5-13.5v-16.6c0-7.4 6.1-13.5 13.6-13.5h63.4c7.5 0 13.5 6.1 13.5 13.5v16.6c0 7.5 6.1 13.5 13.5 13.5h10.9c7.5 0 13.5 6.1 13.5 13.5v47.6c0 7.5-6 13.5-13.5 13.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m608.6 561.5h-10.9c-7.4 0-13.5 6-13.5 13.5v21.8c0 7.5-6 13.5-13.5 13.5h-66.3c-7.5 0-13.5-6-13.5-13.5v-21.8c0-7.5-6.1-13.5-13.5-13.5h-120.9c-7.5 0-13.5-6.1-13.5-13.6v-43.4c0-2.7 0.8-5.4 2.4-7.6l114.6-166c2.5-3.6 6.7-5.8 11.1-5.8h66.3c10.8 0 17.2 12 11.3 21l-79.7 119.8c-6 9 0.5 21 11.2 21 7.5 0 13.6-6.1 13.6-13.5v-16.6c0-7.5 6-13.5 13.5-13.5h63.4c7.5 0 13.5 6 13.5 13.5v16.6c0 7.4 6.1 13.5 13.5 13.5h10.9c7.5 0 13.5 6 13.5 13.5v47.5c0 7.5-6 13.6-13.5 13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m697.7 599.1q-29.1-17.7-45.6-51.3-16.5-33.6-16.5-80.1 0-46.4 16.5-80 16.5-33.7 45.6-51.4 29.1-17.7 67-17.7 37.9 0 67.1 17.7 29.1 17.7 45.6 51.4 16.5 33.6 16.5 80 0 46.5-16.5 80.1-16.5 33.6-45.6 51.3-29.2 17.8-67.1 17.8-37.9 0-67-17.8zm99.6-131.4q0-72.1-32.6-72.1-32.6 0-32.6 72.1 0 72.2 32.6 72.2 32.6 0 32.6-72.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m1180.7 561.5h-10.9c-7.4 0-13.5 6-13.5 13.5v21.8c0 7.5-6 13.5-13.5 13.5h-66.3c-7.4 0-13.5-6-13.5-13.5v-21.8c0-7.5-6-13.5-13.5-13.5h-120.9c-7.5 0-13.5-6.1-13.5-13.6v-43.4c0-2.7 0.8-5.4 2.4-7.6l114.6-166c2.5-3.6 6.7-5.8 11.1-5.8h66.3c10.8 0 17.2 12 11.3 21l-79.7 119.8c-6 9 0.5 21 11.3 21 7.4 0 13.5-6.1 13.5-13.5v-16.6c0-7.5 6-13.5 13.5-13.5h63.4c7.5 0 13.5 6 13.5 13.5v16.6c0 7.4 6.1 13.5 13.5 13.5h10.9c7.5 0 13.5 6 13.5 13.5v47.5c0 7.5-6 13.6-13.5 13.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m139 785.8c41.7 0 76.3-13.4 104.7-40.5 34-32.3 53.7-78.3 72.7-122.8 21.6-50.3 41.9-97.8 79-109.6 16.3-5.3 31.2-3.5 45.4 5.4 62.7 38.9 86.4 194 86.6 195.6l21.2-3.1c-1-6.8-25.5-166.6-96.5-210.7-19.6-12.2-40.9-14.8-63.2-7.6-46.4 14.9-68.6 66.7-92.1 121.6-36.5 85.3-74.3 173.5-205.6 144.6l-63.6-20.5c-5.6-1.8-11.6 1.3-13.4 6.9-1.8 5.6 1.2 11.6 6.9 13.4l65 21c18.8 4.2 36.4 6.3 52.9 6.3z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m500.4 891.4l-22.7-110.4c-7.9-38.1 14.3-76 51.4-87.8 41.5-13.1 85.6 11.2 96.6 53.3l27.9 107z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m500.5 894.3c2.4 10.2 39.1 10.1 82-0.3 42.8-10.3 75.5-26.9 73.1-37-2.4-10.2-39.2-10.1-82 0.3-42.8 10.3-75.5 26.9-73.1 37z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m593 864.4c-0.6 3.4 5.5 7.4 13.7 8.9 8.1 1.4 15.3-0.2 15.9-3.6 0.6-3.4-5.5-7.4-13.7-8.9-8.2-1.4-15.3 0.2-15.9 3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m539 880.9c-0.6 3.5 5.5 7.4 13.7 8.9 8.2 1.5 15.3-0.1 15.9-3.5 0.6-3.5-5.5-7.4-13.7-8.9-8.2-1.5-15.3 0.1-15.9 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m569 706.2c0 0 33.1 12 43.6 46.5 10.5 34.5 19.5 78.8 19.5 78.8l-30 0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m540 667.1l-16 27.8 21-4.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s3",
    d: "m1503.7 637.9l-8.5 18.9c-1.5-0.6-36.6-16.9-68.9-74.3-9.3-16.6-23.6-36-38.7-34.2-10.9 1.3-39.8 16.7-72.6 132.2-35.8 125.9-112.3 208.2-227.4 244.5-74.5 23.6-166.7-26.6-170.6-28.8l5.2-9.4-0.2 0.3 5-9c1.2 0.6 88.5 48 154.3 27.2 108.1-34.1 180-111.7 213.8-230.5 27-95 56.4-143.1 90-147.1 21.3-2.5 41.3 12.5 59.3 44.6 29 51.5 59 65.5 59.3 65.6zm-576.7 240.2l-4.8 8.7 4.8-8.7q0 0 0 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m734.6 802.6l54.7 39.6c4.5 3.3 5.5 9.7 2.2 14.2-3.3 4.6-9.7 5.6-14.2 2.3l-54.6-39.6c-4.6-3.3-5.6-9.6-2.3-14.2 3.3-4.6 9.7-5.6 14.2-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m776.8 742l54.6 39.6c4.6 3.3 5.6 9.7 2.3 14.2-3.3 4.6-9.7 5.6-14.3 2.3l-54.6-39.6c-4.6-3.3-5.6-9.7-2.3-14.2 3.3-4.6 9.7-5.6 14.3-2.3z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m967.9 899.5l-33.9 5 9.4-18.9 32 12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m738.8 859.2l94.5 61.5c32.6 21.2 76 14.3 100.5-15.9 27.4-33.9 20.8-83.8-14.4-109.3l-89.5-65.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m770.5 863.7l21.7-29.4 111.6 80.4c0 0-26.7 13.3-57.5-1.6-30.8-15-75.8-49.4-75.8-49.4z"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/notFound.8c27bfb2c268942aeba49e4ea955d708.svg";
export { ForwardRef as ReactComponent };